// Request context belongs to this browser tab. Capture it before token refreshes.
let context = { seasonId: null, archiveEdit: false };
export function setSeasonRequestContext(seasonId, archiveEdit = false) {
  context = { seasonId, archiveEdit };
}
export function getSeasonRequestContext() {
  return { ...context };
}
